<template>
    <div class="content">
        <div class="content-select">
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="select-title">
                        <div class="title-img">
                            <img src="@/assets/appraisal/select-icon.png" alt="">
                        </div>
                        <div class="title-info">
                            <span>案件受理</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
       <div class="content-header">
        <myTableSearch :isOperate="true" :operateWidth="350" :formData="formData" :tableLabel="tableLabel"
				:queryFn="queryFn" :queryParams="queryParams" :rowClassName="tableRowClassName" @successQuery="successQuery" :searchColLg="6" ref="tableRef" dataRow="rows">

				<template slot="acceptStatus" slot-scope="scope">
					<span :style="{ 
						display: 'inline-flex', 
						alignItems: 'center', 
						justifyContent: 'center',
						minWidth: '60px',
						height: '24px',
						padding: '0 12px',
						borderRadius: '4px',
						fontSize: '12px',
						color: '#fff',
						backgroundColor: scope.row.acceptStatus == '1' ? 'rgb(252, 236, 25)' : 'rgb(80, 194, 28)'
					}">
						{{ scope.row.acceptStatus == '1' ? '待受理' : '已受理' }}
					</span>
				</template>
				<template slot="inquiryStatus" slot-scope="scope">
					<span :style="{ 
						display: 'inline-flex', 
						alignItems: 'center', 
						justifyContent: 'center',
						minWidth: '60px',
						height: '24px',
						padding: '0 12px',
						borderRadius: '4px',
						fontSize: '12px',
						color: '#fff',
						backgroundColor: scope.row.inquiryStatus == '1' ? 'rgb(255, 152, 17)' : 'rgb(0, 118, 86)'
					}">
						{{ scope.row.inquiryStatus == '1' ? '待调查' : '已结案' }}
					</span>
				</template>
				<template slot="caseStatus" slot-scope="scope">
					<span :style="{ 
						display: 'inline-flex', 
						alignItems: 'center', 
						justifyContent: 'center',
						minWidth: '60px',
						height: '24px',
						padding: '0 12px',
						borderRadius: '4px',
						fontSize: '12px',
						color: '#fff',
						backgroundColor: scope.row.caseStatus == '1' ? 'rgb(252, 177, 34)' : 'rgb(32, 201, 128)'
					}">
						{{ scope.row.caseStatus == '1' ? '待认定' : '已认定' }}
					</span>
				</template>
        <template #woundedName="scope">
          <flag :content="scope.row.woundedName" :tip="scope.row.woundedCause" :showTip="scope.row.woundedBlack"></flag>
        </template>
          <template #unitName="scope">
          <flag :content="scope.row.unitName" :tip="scope.row.unitCause" :showTip="scope.row.unitBlack"></flag>
        </template>
				<template slot="tool">
					<div class="toolbar-container">
						<div class="toolbar-left">
							<div class="tool-btn" @click="handleRefresh" title="刷新">
								<img :src="refreshIcon" alt="刷新" class="toolbar-icon">
							</div>
						</div>
						<div class="toolbar-right">
							<el-button type="primary" icon="el-icon-fake custom-icon icon-policy" @click="handleAddAppointment">新增案件</el-button>
							<el-button plain type="info" icon="el-icon-fake custom-icon icon-policy-download" :loading="downloadTemplateLoading" @click="handleDownloadTemplate">下载模版</el-button>
								<el-button plain type="info" icon="el-icon-fake custom-icon icon-policy-insert" @click="handleImport" :loading="importLoading">案件导入</el-button>
<!--              <el-button plain type="info" icon="el-icon-fake el-icon-download"  @click="handleExport"> 案件导出</el-button>-->
<!--              <el-button plain type="info" icon="el-icon-fake el-icon-printer"  @click="handlePrint"> 文书打印</el-button>-->

            </div>
					</div>
				</template>
				<template slot="operate" slot-scope="scope">
					<el-button @click="handleView(scope.row)" size="small" type="text">查看</el-button>
					<el-button v-if="scope.row.caseStatus != '2'" @click="handleEdit(scope.row)" size="small" type="text">编辑</el-button>
<!--					<el-button @click="handleAccept(scope.row)" size="small" type="text">受理</el-button>-->
					<el-button 
						v-if="scope.row.caseStatus != '2'"
						type="text" 
						style="color:rgb(241, 74, 63);" 
						size="small"
						@click="handleDel(scope.row)"
					>删除</el-button>
          <el-button @click="handleSend(scope.row)" size="small" type="text">打印文书</el-button>
				</template>
			</myTableSearch>
		<!-- 案件受理审核 -->
		<acceptDialog
			ref="acceptDialogRef"
			:isDialog="isAcceptDialog"
			:rowData="acceptRowData"
			@handleClose="isAcceptDialog = false"
			@submit="handleAcceptSubmit"
		/>
        <!-- 新增案件 / 查看案件 -->
		<addCaseDialog
			ref="addCaseDialogRef"
			:isDialog="isAddCaseDialog || isSubscribeDialog"
			:isView="isView"
			:editData="editData"
			@handleClose="handleAddCaseDialogClose"
			@submit="handleAddCaseSubmit"
      :type="type"
      @handleEdit="handleEdit"
		/>
        <!-- 导入结果 -->
		<importResultDialog v-if="isImportResultDialog" :isDialog="isImportResultDialog"
			@handleClose="isImportResultDialog = false" @refresh="handleRefresh">
		</importResultDialog>
         <sendDocumentDialog
             :isDialog="isSendDocumentDialog"
             :rowData="sendDocumentRowData"
             :type="3"
             @handleClose="isSendDocumentDialog = false"
         />
       </div>
    </div>
</template>

<script>
import '@/assets/css/base.css'
import { downloadPolicyTemplate, importPolicy, deletePolicy, publishPolicy, unpublishPolicy } from '@/api/policy/management'
import {
  getAcceptPage,
  getAddAccept,
  getAcceptDetail,
  auditAccept,
  getAcceptedit,
  downloadAcceptTemplate, deleteAccept
} from '@/api/recognition'
import { getListByDictType } from '@/api/sys/dictData'
import acceptDialog from './components/acceptDialog.vue'
import addCaseDialog from './components/addCaseDialog.vue'
import importResultDialog from './components/importResultDialog.vue'
import refreshIcon from '@/assets/pages/appointment/refresh.png'
import sendDocumentDialog from '@/views/pages/recognition/document/components/sendDocumentDialog.vue'
import flag from '@/components/flag/index.vue'
export default {
    name: 'PolicyList',
    components: {
		acceptDialog,
		addCaseDialog,
      importResultDialog,
      sendDocumentDialog,
      flag
	},
    data() {
        return {
			refreshIcon,
			currentPage: 1,
			downloadTemplateLoading: false,
			importLoading: false,
			queryParams: {
				pageNum: 1,
				pageSize: 10,
				pageSizes: [10, 20, 50]
			},
			isSubscribeDialog: false,//新增/编辑/查看政策弹窗
			isEdit: false,//是否为编辑模式
			isView: false,//是否为查看模式
			editData: {},//编辑/查看时的数据
			isAcceptDialog: false,//受理审核弹窗
			acceptRowData: {},//受理时的行数据
			isAddCaseDialog: false,//新增案件弹窗
			isImportResultDialog: false,//导入结果弹窗
			importResultData: '',//导入结果
			viewDetailLoading: false,//查看详情加载中
			formData: [
				{
					label: '受理状态',
					type: 'select',
					key: 'acceptStatus',
					colLg: 6,
					data: []
				},
				{
					label: '调查状态',
					type: 'select',
					key: 'inquiryStatus',
					colLg: 6,
					data: []
				},
				{
					label: '认定状态',
					type: 'select',
					key: 'caseStatus',
					colLg: 6,
					data: []
				},
				// {
				// 	label: '申请年度',
				// 	type: 'year',
				// 	format: 'yyyy',
				// 	key: 'applicationYear',
				// 	colLg: 6,
				// 	placeholder: '申请年度'
				// },
				{
					label: '伤者姓名',
					type: 'input',
					key: 'woundedName',
					colLg: 6,
					placeholder: '伤者姓名'
				},
				{
					label: '申请人',
					type: 'input',
					key: 'proposerName',
					colLg: 6,
					placeholder: '申请人'
				},{
					label: '用人单位',
					type: 'input',
					key: 'unitName',
					colLg: 6,
					placeholder: '用人单位'
				},{
					label: '案件编号',
					type: 'input',
					key: 'caseCode',
					colLg: 6,
					placeholder: '案件编号'
				},
				{
					label: '承办人',
					type: 'input',
					key: 'acceptUserName',
					colLg: 6,
					placeholder: '承办人'
				},
				{
					label: '认定结论',
					type: 'select',
					key: 'identificationClauseCode',
					colLg: 6,
					data: [
						{
							dictLabel: '全部',
							dictValue: []
						},
						{
							dictLabel: '予以认定为工伤',
							dictValue: [1, 2, 3, 4, 5, 6, 7]
						},
						{
							dictLabel: '予以视同为工伤',
							dictValue: [8, 9, 10]
						},
						{
							dictLabel: '不予认定为工伤',
							dictValue: [11, 12, 13, 14]
						},
						{
							dictLabel: '撤销',
							dictValue: [15]
						}
					]
				},
				{
					label: '认定条款',
					type: 'input',
					key: 'identificationClauseName',
					colLg: 6,
					placeholder: '认定条款，如 14.1'
				},
				{
					label: '事故发生日期',
					type: 'daterange',
					format: 'yyyy-MM-dd',
					key: 'accidentDate',
					colLg: 12,
					placeholder: '事故发生',
					screen: (value) => {
						if (value && value.length === 2) {
							return {
								accidentDateStart: value[0],
								accidentDateEnd: value[1]
							}
						}
						return {}
					}
				},
				{
					label: '受理日期',
					type: 'daterange',
					format: 'yyyy-MM-dd',
					key: 'applyDateTime',
					colLg: 12,
					placeholder: '受理日期',
					screen: (value) => {
						if (value && value.length === 2) {
						return {
							applyDateStart: value[0],
							applyDateEnd: value[1]
						}
						}
						return {}
					}
				},
				{
					label: '认定日期',
					type: 'daterange',
					format: 'yyyy-MM-dd',
					key: 'determineDate',
					colLg: 12,
					placeholder: '认定日期',
					screen: (value) => {
						if (value && value.length === 2) {
							return {
								identificationDateStart: value[0],
								identificationDateEnd: value[1]
							}
						}
						return {}
					}
				},
			],
			tableLabel: [
				{
					prop: 'caseCode',
					label: '案件编号',
					minWidth: 150
				},
				{
					prop: 'applyDate',
					label: '申请日期',
					width: 120
				},
        {
          prop: 'woundedName',
          label: '伤者姓名',
          minWidth: 200,
          isTooltip:false
        },
        {
          prop: 'proposerName',
          label: '申请人',
          minWidth: 200,
        },
        {
          prop: 'unitName',
          label: '用人单位',
          minWidth: 200,
          isTooltip:false
        },
				{
					prop: 'accidentHarmTypeName',
					label: '伤害类型',
					minWidth: 120
				},
				{
					prop: 'accidentDate',
					label: '事故日期',
					width: 120
				},
				// {
				// 	prop: 'acceptOpinionName',
				// 	label: '受理意见',
				// 	width: 100
				// },
          {
            prop: 'acceptStatus',
            label: '受理状态',
            width: 100
          },
		  {
			prop: 'inquiryStatus',
			label: '调查状态',
			width: 100
		  },
		  {
			prop: 'caseStatus',
			label: '认定状态',
			width: 100
		  },
			{
					prop: 'acceptData',
					label: '受理日期',
					width: 120
				}
			],
      type:1,//1 新增 2 编辑 3 查看
      isSendDocumentDialog:false,
      sendDocumentRowData:{}
		}
    },
    mounted() {
        this.loadPolicyTagData()
    },
    methods: {
      tableRowClassName({row, rowIndex}) {
        if(row.woundedBlack || row.unitBlack){
        return 'row-highlight';
        }
      },
    handleSend(row) {
      this.sendDocumentRowData = row || {}
      this.isSendDocumentDialog = true
    },
		// 获取列表数据
		queryFn(queryParams) {
			return getAcceptPage(queryParams)
		},
		// 获取筛选下拉字典
		async loadPolicyTagData() {
			const res = await getListByDictType('industraial_injury_accept')
			if (res && res.code === 200 && res.data) {
				this.updateFormDataSelect('acceptStatus', res.data)
			}
			// 调查状态：与案件调查页一致
			const inquiryRes = await getListByDictType('industrial_injury_case_status')
			if (inquiryRes && inquiryRes.code === 200 && inquiryRes.data) {
				this.updateFormDataSelect('inquiryStatus', inquiryRes.data)
			}
			// 认定状态：与文书认定页一致
			const caseRes = await getListByDictType('determination_case_status')
			if (caseRes && caseRes.code === 200 && caseRes.data) {
				this.updateFormDataSelect('caseStatus', caseRes.data)
			}
		},
		// 更新筛选下拉选项
		updateFormDataSelect(key, data) {
			if (!data) return
			const index = this.formData.findIndex(item => item.key === key)
			if (index !== -1) {
				const dataWithAll = [
					{
						dictLabel: '全部',
						dictValue: ''
					},
					...data
				]
				this.$set(this.formData[index], 'data', dataWithAll)
			}
		},
		// 上一页
		handlePrevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
				this.queryParams.pageNum = this.currentPage;
				this.$refs.tableRef && this.$refs.tableRef.handleSearch();
			}
		},
		// 下一页
		handleNextPage() {
			this.currentPage++;
			this.queryParams.pageNum = this.currentPage;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},
		// 刷新列表
		handleRefresh() {
			this.queryParams.pageNum = 1;
			this.currentPage = 1;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},
		// 删除
		handleBatchDelete() {
			this.$refs.tableRef && this.$refs.tableRef.deleteAll();
		},
		// 下载导入模板
		handleDownloadTemplate() {
			this.downloadTemplateLoading = true
      downloadAcceptTemplate().then(res => {
				if (res) {
					this.downloadBlobFile(res, '案件导入模板.xls');
				}
			}).finally(() => {
				this.downloadTemplateLoading = false
			})
		},
    // 导入案件
		handleImport() {
      this.isImportResultDialog=true
    },
		// 新增案件
		handleAddAppointment() {
			this.isView = false
			this.editData = {}
			this.isAddCaseDialog = true
      this.type = 1
		},
		// 新增/查看案件弹窗关闭
		handleAddCaseDialogClose() {
			this.isAddCaseDialog = false
			this.isSubscribeDialog = false
			this.isView = false
			this.editData = {}
		},
		handleAddCaseSubmit(submitData) {
      if(this.type==2){
        submitData.id = this.editData.id
      }
      let api=this.type==1?getAddAccept(submitData):getAcceptedit(submitData)
			api.then(res => {
				if (res && res.code === 200) {
					this.$message.success(this.type==1?'新增':'修改'+'案件成功')
					this.handleAddCaseDialogClose()
					this.$refs.addCaseDialogRef && this.$refs.addCaseDialogRef.finishSubmit()
					this.handleRefresh()
				} else {
					this.$message.error(res.msg || (this.type==1?'新增':'修改')+'案件失败')
					this.$refs.addCaseDialogRef && this.$refs.addCaseDialogRef.failSubmit()
				}
			}).finally(() => {
        this.$refs.addCaseDialogRef && this.$refs.addCaseDialogRef.failSubmit()
      })
		},
    // 编辑
      handleEdit(row){
        const id = row.id || row.caseCode
        this.type=2
        if (id == null || id === '') {
          this.$message.warning('无法获取案件标识')
          return
        }
        this.viewDetailLoading = true
        getAcceptDetail({ id }).then(res => {
          if (res && res.code === 200 && res.data) {
            this.editData = { ...res.data }
            this.isSubscribeDialog = true
            this.isView=false
          } else {
            this.$message.error(res && res.msg ? res.msg : '获取详情失败')
          }
        }).catch(() => {
          this.$message.error('获取详情失败')
        }).finally(() => {
          this.viewDetailLoading = false
        })
      },
		// 查看案件（通过详情接口拉取数据，复用新增案件弹框只读展示）
		handleView(row) {
			const id = row.id || row.caseCode
      this.type=3
			if (id == null || id === '') {
				this.$message.warning('无法获取案件标识')
				return
			}
			this.viewDetailLoading = true
			getAcceptDetail({ id }).then(res => {
				if (res && res.code === 200 && res.data) {
					this.isView = true
					this.editData = { ...res.data }
					this.isSubscribeDialog = true
				} else {
					this.$message.error(res && res.msg ? res.msg : '获取详情失败')
				}
			}).catch(() => {
				this.$message.error('获取详情失败')
			}).finally(() => {
				this.viewDetailLoading = false
			})
		},
		// 受理
		handleAccept(row) {
			this.acceptRowData = { ...row }
			this.isAcceptDialog = true
		},
		// 受理审核提交：调用受理接口，仅传 id + 受理相关字段
		handleAcceptSubmit(submitData) {
			const id = submitData.id
			if (id == null || id === '') {
				this.$message.warning('无法获取案件标识')
				this.$refs.acceptDialogRef && this.$refs.acceptDialogRef.failSubmit()
				return
			}
			const payload = {
				id,
				acceptOpinionCode: submitData.acceptOpinionCode,
				acceptOpinionName: submitData.acceptOpinionName,
				acceptData: submitData.acceptData,
				acceptUserId: submitData.acceptUserId,
				acceptUserName: submitData.acceptUserName,
				acceptExplain: submitData.acceptExplain
			}
			auditAccept(payload).then(res => {
				if (res && res.code === 200) {
					this.$message.success('受理成功')
					this.$refs.acceptDialogRef && this.$refs.acceptDialogRef.finishSubmit()
					this.isAcceptDialog = false
					this.handleRefresh()
				} else {
					this.$message.error(res && res.msg ? res.msg : '受理失败')
					this.$refs.acceptDialogRef && this.$refs.acceptDialogRef.failSubmit()
				}
			}).catch(() => {
				this.$message.error('受理失败')
				this.$refs.acceptDialogRef && this.$refs.acceptDialogRef.failSubmit()
			})
		},
		// 更新总数
		successQuery(e) {
			this.syrkNum = e.total;
		},
  //     删除
      handleDel(row){
        const id = row.id || row.caseCode
        if (id == null || id === '') {
          this.$message.warning('无法获取案件标识')
          return
        }
        this.$confirm('此案件已受理，确定要删除吗？', '提示', { type: 'warning' })
          .then(() => {
            deleteAccept({id}).then(res => {
              if (res && res.code === 200) {
                this.$message.success('删除成功')
                this.handleRefresh()
              } else {
                this.$message.error(res && res.msg ? res.msg : '删除失败')
              }
            }).catch(() => {
              this.$message.error('删除失败')
            })
          })
          .catch(() => {})
      },
      //导出
      handleExport(){

      }
	},
}
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;

    &-select{
        height: 50px;
        .select-title{
            height: 46px;
            background: url('~@/assets/appraisal/selectBg.png') no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            gap: 12px;
            padding-left: 16px;
            .title-img{
                width: 18px;
                height: 18px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .title-info{
                color: var(--vt-c-black-mute-soft);
                font-size: 16px;
                font-weight: 700;
            }
        }
        .select-serch{
            margin-top: 12px;
            display: flex;
            align-items: center;
            gap: 8px;
            .serch-hint{
                color: var(--vt-c-black-mute-soft);
                font-size: 14px;
                font-weight: 400;
            }
            .serch-info{
                height: 28px;
                display: flex;
                align-items: center;
                gap: 12px;
                .info-item{
                    width: 120px;
                    height: 28px;
                    text-align: center;
                    line-height: 28px;
                    background: var(--vt-c-blue-mute);
                    color: var(--vt-c-blue);
                    border-radius: 2px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    
                    &:hover {
                        opacity: 0.8;
                    }
                    
                    &.active {
                        background: var(--vt-c-blue);
                        color: var(--vt-c-white);
                    }
                    
                    &:active:not(.active) {
                        transform: scale(0.98);
                    }
                }
            }
        }
    }
    &-header{
        margin-top: 16px;
        padding: 0 24px;
        
        /deep/.myTableSearch {
            padding: 0;
        }
    }
}

.link-text {
    color: #409eff;
    text-decoration: none;
    cursor: pointer;
    
    &:hover {
        text-decoration: underline;
    }
}

.toolbar-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;

    .toolbar-icon {
        width: 24px;
        height: 24px;
    }

    .add-icon {
        width: 20px;
        height: 20px;
        margin-right: 6px;
    }

    .toolbar-left {
        display: flex;
        align-items: center;
        gap: 12px;
		.tool-btn {
			width: 36px;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px solid #dcdfe6;
			cursor: pointer;
			transition: all 0.2s;
			background-color: #FCFCFCFF;
		}
        .list-title {
            font-size: 14px;
            font-weight: 400;
            color:var(--vt-c-blue-soft);
        }
    }

    .toolbar-right {
        display: flex;
        align-items: center;
        gap: 12px;

        .import-upload {
            display: inline-block;
            
            /deep/.el-upload {
                display: inline-block;
            }
        }

        .el-button {
            height: 36px;
            padding: 0 16px;
        }
    }
}
.content-header{
  flex: 1;
  display: flex;
  flex-flow: column;
  overflow-y: hidden;
}
/deep/.row-highlight{
  background-color: #d9af891a !important;
  >.el-table__cell:nth-child(1){
    border-left: 4px solid #faad14;
  }
}
/deep/.el-table__fixed-right{
  background-color: #fff;
}
</style>